import { getCalibrationCenter } from '../api/api'
import { useCenterStore } from '../store/CenterStore'
import { Logger } from '../logger'

/**
 * Re-reads the active center into CenterStore. centerDetail is persisted, so without this a
 * signed-in user keeps the copy from their last center switch - including the admin switches
 * (AI Report, Scheduler) that decide what the sidebar offers (CAR-4038).
 */
export const refreshCenterDetail = async (ccId = useCenterStore.getState().ccId) => {
  if (!ccId) return
  try {
    const response = await getCalibrationCenter({ ccid: ccId })
    // The user may have switched centers while this was in flight.
    if (response?.status === 200 && useCenterStore.getState().ccId === ccId) {
      useCenterStore.getState().setCenterDetail(response.data)
    }
  } catch (error) {
    Logger.error({ message: error, payload: { file: 'refreshCenterDetail', ccId } })
  }
}
